import ko from "./ko";
import en from "./en";
import ja from "./ja";
import km from "./km";

export const resources = {
  ko,
  en,
  ja,
  km,
} as const;

export const NAMESPACES = [
  "auth",
  "common",
  "graph",
  "landing",
  "projects",
  "timeSeries",
  "worksite",
  "drone",
] as const;
export type Namespace = (typeof NAMESPACES)[number];
